<template>
  <div class="tw:flex tw:flex-col tw:gap-y-3 tw:md:flex-row tw:md:gap-x-3 tw:flex-wrap">
    <FilterSelect
      id="performance-range-select"
      class="tw:w-[20%] tw:min-w-[200px]"
      :options="periodTypeOptions"
      @select="changePeriodType"
      name="timeframe"
      :label="$t('rc_performance_timeframe')"
      :disabled="false"
      :value="periodTypeValue"
      :withTranslations="true"
      :valueLabel="periodTypeValue?.label"
    />
    <div v-if="periodType == 0" class="tw:flex tw:flex-col tw:md:flex-row tw:flex-1 tw:gap-2">
      <BaseTextField
        size="big"
        :id="'datefrom'"
        :type="'date'"
        aria-label="Date from"
        :value="startDate"
        :max="getMaxStartDate"
        :min="getMinStartDate"
        @onChange="changeStartDate"
      />
      <BaseTextField
        size="big"
        :id="'dateto'"
        :value="endDate"
        :max="getMaxEndDate"
        :min="getMinEndDate"
        :type="'date'"
        aria-label="Date to"
        @onChange="changeEndDate"
      />
    </div>
    <ButtonGroup
      v-if="selectedDisplayType === 'graph'"
      :items="aggregationOptions"
      :value="aggregationType"
      @onClick="changeAggregationType"
    />
  </div>
</template>
<script setup>
import { computed } from 'vue'
import BaseTextField from '@/components/base/inputs/BaseTextField.vue'
import ButtonGroup from '@/components/ButtonGroup.vue'
import FilterSelect from '@/components/base/filters/FilterSelect.vue'

import appAnalytics from '@/utils/tracking'

import { selectedAccommodationId } from '@/layouts/queries'

const props = defineProps({
  aggregationType: String,
  periodType: Number,
  selectedDisplayType: String,
  startDate: String,
  endDate: String,
})
const emit = defineEmits(['changePeriodType', 'changeAggregationType', 'changeStartDate', 'changeEndDate'])
const changePeriodType = e => {
  appAnalytics.track(appAnalytics.events.HOMEPAGE_PERFORMANCE_TIMEFRAME_CHANGED, {
    accommodationId: selectedAccommodationId.value,
    timeframe: e.option.value,
  })
  emit('changePeriodType', e.option.value)
}
const changeAggregationType = e => emit('changeAggregationType', e)
const changeStartDate = e => emit('changeStartDate', e)
const changeEndDate = e => emit('changeEndDate', e)

const periodTypeOptions = [
  { id: 5, label: 'last_6_months', value: 180 },
  { id: 0, label: 'performance_last90days', value: 90 },
  { id: 1, label: 'performance_last30days', value: 30 },
  { id: 2, label: 'performance_last7days', value: 7 },
  { id: 3, label: 'performance_custom_dates', value: 0 },
]

const aggregationOptions = [
  { label: 'performance_aggregation_daily', value: 'daily' },
  { label: 'performance_aggregation_weekly', value: 'weekly' },
  { label: 'performance_aggregation_monthly', value: 'monthly' },
]

const periodTypeValue = computed(() => periodTypeOptions.find(item => item.value === props.periodType))
const getMaxStartDate = computed(() => {
  let date = new Date(props.endDate)
  date = date.setDate(date.getDate() - 1)
  return new Date(date).toISOString().split('T')[0]
})

const getMinStartDate = computed(() => {
  let date = new Date()
  date.setFullYear(date.getFullYear() - 1)
  return new Date(date).toISOString().split('T')[0]
})

const getMaxEndDate = computed(() => {
  let date = new Date()
  date = date.setDate(date.getDate() - 1)
  return new Date(date).toISOString().split('T')[0]
})
const getMinEndDate = computed(() => {
  // prevents selecting end date before start date
  let date = new Date(props.startDate).getTime() + 1000 * 60 * 60 * 24
  new Date(date).setFullYear(new Date(date).getFullYear() - 1)
  return new Date(date).toISOString().split('T')[0]
})
</script>
